var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubjectStory = function SvgSubjectStory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "subject-story_svg__Layer_1",
    viewBox: "0 0 64 64"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".subject-story_svg__cls-1{fill:none;stroke:#333;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "subject-story_svg__subject-story"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "subject-story_svg__subject-story_x5F_box",
    width: 56,
    height: 56,
    x: 4,
    y: 4,
    className: "subject-story_svg__cls-1",
    rx: 8,
    ry: 8
  }), /*#__PURE__*/React.createElement("g", {
    id: "subject-story_svg__subject-story_x5F_lines"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.5 15.5h-29M46.5 26.5h-29M46.5 37.5h-29M46.5 48.5h-29",
    className: "subject-story_svg__cls-1"
  })))));
};
export default SvgSubjectStory;